import React from 'react';
import { FormattedMessage } from 'react-intl';

import withInnerRef from 'lib/react/with-inner-ref';
import Localizable from 'lib/intl/localizable';
import Styled from 'lib/styles/styled-deprecated';
import ImageView from 'lib/images/responsive-image-view';

import Modal from 'four-nets/ui-v2/modal/modal';

import defaultStyles from './avatar-rules-stack-view.scss';

const avatarRule1 = require('./img/avatar-rule1.png');
const avatarRule2 = require('./img/avatar-rule2.png');
const avatarRule3 = require('./img/avatar-rule3.png');

@Localizable()
@Styled(defaultStyles)
@withInnerRef()
class AvatarRulesStackView extends React.Component {
    state = { open: false };

    onClose = () => {
        this.props.onClose();
    };

    render() {
        const { styles, open } = this.props;

        return (
            <Modal title={<FormattedMessage id='SUITABLE_AND_UNSUITABLE_AVATARS' />} open={open} onClose={this.onClose}>
                <div className={styles.avatarRulesStack}>
                    <FormattedMessage id='AVATAR_RULE_OK_1' values={{ gender: true }}>
                        {msg => (
                            <React.Fragment>
                                <div className={styles.rule1} dangerouslySetInnerHTML={{ __html: msg }} />
                                <div className={styles.rule1Image}>
                                    <ImageView aspectFill={true} image={avatarRule1} alt={msg} />
                                </div>
                            </React.Fragment>
                        )}
                    </FormattedMessage>
                    <FormattedMessage id='AVATAR_RULE_OK_2' values={{ gender: true }}>
                        {msg => (
                            <React.Fragment>
                                <div className={styles.rule2} dangerouslySetInnerHTML={{ __html: msg }} />
                                <div className={styles.rule2Image}>
                                    <ImageView aspectFill={true} image={avatarRule2} alt={msg} />
                                </div>
                            </React.Fragment>
                        )}
                    </FormattedMessage>
                    <FormattedMessage id='AVATAR_RULE_OK_3' values={{ gender: true }}>
                        {msg => (
                            <React.Fragment>
                                <div className={styles.rule3}>
                                    <span dangerouslySetInnerHTML={{ __html: msg }} />
                                    <span className={styles.lighterText}>
                                        {' '}
                                        <FormattedMessage id='AVATAR_WITH_CHILD_RULE' values={{ gender: true }} />
                                    </span>
                                </div>
                                <div className={styles.rule3Image}>
                                    <ImageView aspectFill={true} image={avatarRule3} alt={msg} />
                                </div>
                            </React.Fragment>
                        )}
                    </FormattedMessage>
                </div>
            </Modal>
        );
    }
}

export default AvatarRulesStackView;
